<script setup lang="ts">
import type { useFilterState } from '~/composables/filter/useFilterState'
import type {
  EstateListingEssentialResponse,
  EstateListingResponse,
} from '~/types/api/EstateListing'

const props = defineProps<{
  officesResponse: EstateListingResponse | EstateListingEssentialResponse
  filterState: ReturnType<typeof useFilterState>
  filterKey: string
}>()

const selected = ref(!!props.filterState.filterValues.value[props.filterKey])

function onButtonClick() {
  selected.value = !selected.value

  updateFilter()
}

function updateFilter() {
  if (selected.value) {
    props.filterState.actions.updateValue(props.filterKey, true)
  } else {
    props.filterState.actions.deleteValue(props.filterKey)
  }

  props.filterState.actions.submitFilter()
}

watch(
  () => props.filterState.filterValues.value[props.filterKey],
  (newValue) => {
    if (!!newValue === selected.value) return

    selected.value = !!newValue
  }
)
</script>

<template>
  <IButton
    class="c-filter-checkbox"
    :active="selected"
    size="sm"
    color="primary"
    :disabled="
      !selected && (officesResponse.filter?.[filterKey]?.[1] ?? 0) === 0
    "
    @click="onButtonClick"
  >
    <slot />

    <div class="sc-count">
      ({{ officesResponse.filter?.[filterKey]?.[1] ?? '0' }})
    </div>
  </IButton>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;

.c-filter-checkbox {
  --button--background: var(--color-green-primary-light-2);
  --button--color: var(--color-dark);

  --button--hover--background: var(--color-gray-200);

  --button--active--background: var(--color-primary);
  --button--active--color: var(--color-light);

  :deep(.button-content) {
    width: 100%;
    text-align: left;
    justify-content: space-between;
  }

  .sc-count {
    font-weight: 400;
    opacity: 0.5;
    margin-left: 5px;
    min-width: 30px;
    text-align: right;
  }
}
</style>
